<div class="navigation-container">
  <!-- Back button -->
  <div class="nav-button">
    <!-- Content for expanded sidebar -->
    <div
      *ngIf="isExpanded"
      class="flex flex-row gap-2 items-center cursor-pointer"
      [ngClass]="{ 'text-gray-500': !canNavigateBack(), 'hover:bg-gray-100': canNavigateBack() }"
      (click)="onClickOnBack()"
      [attr.disabled]="!canNavigateBack() || null"
    >
      <button
        [disabled]="!canNavigateBack()"
        class="arrow-button back-button"
        mat-mini-fab
        color="primary"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span class="text-sm ml-2" *ngIf="previousPath && canNavigateBack()">{{ previousPath }}</span>
      <span
        class="text-sm ml-2"
        *ngIf="!previousPath && canNavigateBack()"
        translate="COMPONENT.HISTORY_NAVIGATION.back"
      ></span>
    </div>

    <!-- Content for collapsed sidebar -->
    <div *ngIf="!isExpanded">
      <button
        (click)="onClickOnBack()"
        [disabled]="!canNavigateBack()"
        class="arrow-button back-button"
        mat-mini-fab
        color="primary"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>
  </div>

  <!-- Forward button -->
  <div class="nav-button">
    <!-- Content for expanded sidebar -->
    <div
      *ngIf="isExpanded"
      class="flex flex-row gap-2 items-center cursor-pointer"
      [ngClass]="{
        'text-gray-500': !canNavigateForward(),
        'hover:bg-gray-100': canNavigateForward(),
      }"
      (click)="onClickOnForward()"
      [attr.disabled]="!canNavigateForward() || null"
    >
      <button
        [disabled]="!canNavigateForward()"
        class="arrow-button forward-button"
        mat-mini-fab
        color="primary"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
      <span class="text-sm ml-2" *ngIf="nextPath && canNavigateForward()">{{ nextPath }}</span>
      <span
        class="text-sm ml-2"
        *ngIf="!nextPath && canNavigateForward()"
        translate="COMPONENT.HISTORY_NAVIGATION.forward"
      ></span>
    </div>

    <!-- Content for collapsed sidebar -->
    <div *ngIf="!isExpanded">
      <button
        (click)="onClickOnForward()"
        [disabled]="!canNavigateForward()"
        class="arrow-button forward-button"
        mat-mini-fab
        color="primary"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
